/**
 * A handler factory that dynamically maps mouse and touch events
 * to ripple animation triggers.
 * @param instance a WithRipple instance
 * @param eventName touch or mouse event
 * @param action `start` or `stop` the ripple
 * @param cb an internal callback function for when then event occurs
 */
function handlerFactory( // TODO: how the hell to you type this to be an instance of WithRipple?
instance, eventName, action, cb) {
  return function handleEvent(event) {
    // let any internal callbacks know that an event has occured
    if (cb) {
      cb.call(instance, event);
    } // Cancel if default was prevented


    if (event.defaultPrevented) {
      return false;
    } // Get the ripple to start or stop


    if (instance.ripple) {
      instance.ripple[action](event);
    } // Pass the event on to any mouse/touch handler props passed into WithRipple


    if (instance.props && typeof instance.props["on".concat(eventName)] === 'function') {
      instance.props["on".concat(eventName)](event);
    }

    return true;
  };
}

export { handlerFactory };